export default {"src":"/_next/static/image/public/images/flags/flag_1441.2024d824669674c6087bb081659fcec7.svg","height":16,"width":24};